import React, { Component, createElement } from "react";
import { Timeline } from "../Timeline";
import Button from "../button/button";

/******************************************************************
*******************************************************************

HOW TO USE

const items = {
	activeColor: "success",
	data: [
		{
			label: "<strong>Indicação<br />enviada</strong>",
			description: "15/02/1990 <br /> 12:12",
			className: "teste",
			active: true
		},
		{
			label: "<strong>Solicitação<br />de vínculo</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: true
		},
		{
			label: "<strong>Vínculo<br />confirmado</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: true,
			color: "danger",
			icon: "<i class='icon-close' style='color: white;'></i>"
		},
		{
			label: "<strong>Em análise na<br />MaxMilhas</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: false
		},
		{
			label: "<strong>Vínculo<br />ativado</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: false
		}
	]
};

<ExpansiveTicket
    timelineConfig={items}
    description="Indicação enviada ao participante"
    partner="Djeison H***"
    status="Em negociação"
    statusColor="primary">
    Content
</ExpansiveTicket>

*******************************************************************
******************************************************************/

class ExpansiveTicket extends Component {
	constructor(props) {
		super(props);

		this.state = {
			open: false
		};
	}

	handleExpansive() {
		this.setState({
			open: !this.state.open
		});
	}

	render() {
		const { className, children, timelineConfig, description, partner, step } = this.props;

		const style = ["expansive-ticket-component", className].join(" ");

		const expansiveButton = createElement(
			Button,
			{
				className: "btn btn-icon",
				onClick: () => this.handleExpansive()
			},
			<i className={this.state.open ? "icon-arrow-up" : "icon-arrow-down"} />
		);

		function includeStatusDots() {
			const { data, activeColor, inactiveColor, lengthMax } = timelineConfig;
			return data.map((val, idx) => {
				return (
					idx === 5 ?
						<span
							key={`dot-${idx}`}
							className={`single-dot ${
								inactiveColor
							}`}
						/> 
					:
						<span
							key={`dot-${idx}`}
							className={`single-dot ${
								lengthMax || val.active ? activeColor : val.active === false && inactiveColor
							}`}
						/> 
				);
			});
		}

		return (
			<div className={style}>
				<div className={`expansive-ticket-component__body ${timelineConfig.parent.className}`}>
					<div className="expansive-ticket-component__body--first-line">
						<strong className="expansive-ticket-component__body--first-line--name">
							{partner}
						</strong>
						<div className="expansive-ticket-component__body--first-line--right-content">
							{description}{" "}
							<span className={`status-content ${timelineConfig.parent.className}`}>
								{" "}
								{timelineConfig.parent.statusTitle}
							</span>
						</div>
					</div>
					<div className="expansive-ticket-component__body--division">
						<hr />

						<div className="expansive-ticket-component__body--division--dots">
							{includeStatusDots()}
						</div>
						<div
							className={`expansive-ticket-component__body__details-button${
								this.state.open ? " expansive-ticket-component__body__details-button--open" : ""
							}`}
						>
							{expansiveButton}
						</div>
					</div>
					<div className="expansive-ticket-component__body--second-line">{children}</div>
				</div>
				<div
					className={`expansive-ticket-component__hide-content ${
						this.state.open ? "open-card" : "close-card"
					}`}
				>
					<Timeline config={timelineConfig} />
				</div>
			</div>
		);
	}
}

export default ExpansiveTicket;
